module.exports = __webpack_public_path__ + "assets/Sigma.3b68260b26f7e71c7a4c121c20b472d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Sigma.png
// module id = 846
// module chunks = 0